import React, { Fragment } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PlayStationButton from 'components/CTAButtons/PlayStationButton';
import FavoriteButton from 'components/CTAButtons/FavoriteButton';
import * as cssVariable from 'cssVariables';
import SocialShare from 'components/SocialShare';
import { Station } from 'api/models';
import styles from './HeaderBanner.styles';
import Metadata from 'api/models/Metadata';
import { isTouch } from 'util/device';
import useBrowser from 'components/hooks/useBrowser';
import { breakpoints } from 'components/theme/breakpoints';

interface HeaderBanner {
  imageUrl: string;
  title: string;
  logoUrl: string;
  description: string;
  color: string;
  station: Station;
  metadata?: Metadata;
}

const useStyles = createUseStyles(styles, { name: 'HeaderBanner' });
const HeaderBanner = (props: HeaderBanner): JSX.Element => {
  const { imageUrl, logoUrl, title, station, metadata, description, color } = props;

  const browser = useBrowser();
  const classes = useStyles();

  const favoriteButtonProps = {
    minimalButton: browser.down(breakpoints.ml),
    ...station,
  };

  const socialShareProps = {
    subject: title,
    description: metadata?.share?.description,
    link: metadata?.share?.url,
    title: metadata?.share?.title,
    size: 40,
    color: cssVariable.white,
  };

  return (
    <div className={classNames(classes.container, { [classes.containerTouch]: isTouch })} style={{ background: color }}>
      {logoUrl && <img data-testid="header-banner-logo" className={classes.logo} src={logoUrl} alt={title} />}
      <div className={classes.contentContainer}>
        <h1 className={classes.title}>{title}</h1>
        {description && <p className={classes.content}>{description}</p>}
      </div>
      <div className={classes.buttonContainer}>
        {station && (
          <Fragment>
            <PlayStationButton station={station} />
            {browser.up(breakpoints.xs) && (
              <FavoriteButton {...favoriteButtonProps} data-testid={'headerBanner-favourite'} />
            )}
          </Fragment>
        )}
        {metadata && browser.up(breakpoints.xs) && <SocialShare {...socialShareProps} />}
      </div>
      {imageUrl && <img className={classes.image} src={imageUrl} alt={title} />}
    </div>
  );
};

export default HeaderBanner;
